import { createStore } from 'satcheljs';
import type { ProjectId } from 'owa-timestream-types';
import { BoardEditorLoadState } from './schema';

export default createStore('calendar-boardEditor', {
    isOpen: false,
    projectId: undefined as ProjectId | undefined,
    name: '',
    loadState: BoardEditorLoadState.Idle,
});
